module.exports = __webpack_public_path__ + "static/img/AF.3ec459e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/AF.svg
// module id = TauI
// module chunks = 55